'use client';

import { AnalyticsSkuViewed } from '@ria-client/segment/Analytics/AnalyticsSkuViewed';
import type { MarketplaceEntityForProductCardType as MarketplaceEntity } from '@ria-client/supergraph/structuredContent/hydration/MarketplaceProductCard/types';
import { CtaButton } from '@ria-client/tw-shared-ui';
import type { NodeProps } from '../types';
import { Drivers } from './lib/marketplace-product-card/drivers';
import { Header } from './lib/marketplace-product-card/header';
import { HeaderImage } from './lib/marketplace-product-card/header-image';
import { MarketplaceProductCardTabs } from './lib/marketplace-product-card/tabs';

export interface MarketplaceProductCardProps extends Record<string, unknown> {
  id: string;
  marketplaceEntity: MarketplaceEntity;
}

export function MarketplaceProductCard({ props }: NodeProps<MarketplaceProductCardProps>) {
  const { marketplaceEntity } = props;
  const {
    id,
    institution,
    monetizable,
    name,
    product,
    productType,
    cta,
    driverAccountMinimum,
    driverFees,
    driverPromotion,
  } = marketplaceEntity;
  const analyticsPayload = {
    index: 0,
    institutionId: institution.id,
    offerId: id,
    productId: product.id,
    productType,
    monetizable,
  };

  return (
    <AnalyticsSkuViewed
      additionalAttributes={{ page_type: 'review' }}
      impressionPosition={0}
      impressionSection="investing_review"
      institutionId={institution.id}
      institutionName={institution.name}
      level="offer"
      monetizable={monetizable}
      name={name}
      offerId={id}
      offerName={name}
      productId={product.id}
      productName={product.name}
      productType={productType}
      source="marketplace"
    >
      <section className="border border-border">
        <div className="grid grid-cols-1 px-6 py-7 sm:grid-cols-[221px_1.75rem_minmax(0,1fr)] sm:px-8 sm:py-8">
          <div className="mb-6 sm:col-start-1 sm:row-start-1 sm:mb-8">
            <HeaderImage marketplaceEntity={marketplaceEntity} />
          </div>
          <div className="sm:col-start-3 sm:row-start-1">
            <Header marketplaceEntity={marketplaceEntity} />
          </div>
          <div className="sm:col-start-1 sm:row-start-2 md:col-start-1">
            <CtaButton analyticsPayload={analyticsPayload} cta={cta} fullWidth />
          </div>
          <div className="sm:col-span-3 sm:row-start-3 sm:mt-8 md:col-start-3 md:col-span-1 md:row-start-2 md:mt-0">
            <Drivers drivers={[driverFees, driverAccountMinimum, driverPromotion]} />
            <MarketplaceProductCardTabs marketplaceEntity={marketplaceEntity} />
          </div>
        </div>
      </section>
    </AnalyticsSkuViewed>
  );
}
